import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Loader from "../../../components/loader";
import Icon from "../../../components/icons";
import toast from "react-hot-toast";
import Button from "../../../components/elements/button";
import Input from "../../../components/elements/form/input";
import SelectBox from "../../../components/elements/form/selectBox";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import { useSagesApi } from '../../../store/api/hooks/sageApiHook';
import { showLocalDateTime } from "../../../_common/functions";
import { PAGE_SIZE } from '../../../_common/constant';
import { useAssetsApi } from "../../../store/api/hooks/assetsApiHook";
import { useFacilitiesApi } from "../../../store/api/hooks/facilitiesApiHook";
import Pagination from "../../../components/pagination";
import { useVendorsApi } from "../../../store/api/hooks/vendorsApiHook";

interface Props {
    onClose: () => void;
    onSelect: (assets: any[]) => void;
    item?: any;
};

const SageMDModalContent: React.FC<Props> = ({ onClose, onSelect, item }) => {
    const sageApi: any = useSagesApi();
    const vendorApi = useVendorsApi();
    const { showLoader, hideLoader } = useAppLoader();
    const [working, setWorking] = useState<boolean>(false);
    const [agrowData, setagrowData] = useState<any>(null);
    const [accrowData, setaccrowData] = useState<any>(null);
    const [fbrowData, setfbrowData] = useState<any>(null);
    const [iglrowData, setiglrowData] = useState<any>(null);
    const [locrowData, setlocrowData] = useState<any>(null);
    const [deptrowData, setdeptrowData] = useState<any>(null);
    const [vendorRowData, setvendorRowData] = useState<any>(null);
    const [currentPage, setCurrentPage] = useState<number>(1);

    let totalRecords = 0;
    if (item === 'syncAccountGroups') totalRecords = agrowData?.totalRecord || 0;
    else if (item === 'syncAccounts') totalRecords = accrowData?.totalRecord || 0;
    else if (item === 'syncFinancialBook') totalRecords = fbrowData?.totalRecord || 0;
    else if (item === 'syncItemGL') totalRecords = iglrowData?.totalRecord || 0;
    else if (item === 'syncLocation') totalRecords = locrowData?.totalRecord || 0;
    else if (item === 'syncDepartment') totalRecords = deptrowData?.totalRecord || 0;
    else if (item === 'syncVendor') totalRecords = vendorRowData?.totalRecord || 0;

    useEffect(() => {
        if (!item) return;

        showLoader();
        setWorking(true);

        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
        };

        const onSuccess = (resp: any, setData: Function) => {
            setData(null);
            if (resp.successful) {
                setData(resp);
            }
            setWorking(false);
            hideLoader();
        };

        const onError = (error: any) => {
            toast.error(error);
            setWorking(false);
            hideLoader();
        };

        switch (item) {
            case 'syncAccountGroups':
                sageApi.getSyncAccountGroups(payload, (resp: any) => onSuccess(resp, setagrowData), onError);
                break;
            case 'syncAccounts':
                sageApi.getSyncAccount(payload, (resp: any) => onSuccess(resp, setaccrowData), onError);
                break;
            case 'syncFinancialBook':
                sageApi.getSyncFinancialBook(payload, (resp: any) => onSuccess(resp, setfbrowData), onError);
                break;
            case 'syncItemGL':
                sageApi.getSyncItemGL(payload, (resp: any) => onSuccess(resp, setiglrowData), onError);
                break;
            case 'syncLocation':
                sageApi.getSageFacilityList(payload, (resp: any) => onSuccess(resp, setlocrowData), onError);
                break;
            case 'syncDepartment':
                sageApi.getSageDepartmentList(payload, (resp: any) => onSuccess(resp, setdeptrowData), onError);
                break;
            case 'syncVendor':
                payload.isSageSynced = true;
                vendorApi.GetVendorList(payload, (resp: any) => onSuccess(resp, setvendorRowData), onError);
                break;
            default:
                setWorking(false);
                hideLoader();
                break;
        }
    }, [item, currentPage]);

    return (
        <div className="modal-box max-w-[90%] w-[50rem] p-4">
            {/* Sticky header */}
            <div className="flex items-center justify-between border-b border-[#8D6E63] pb-2 mb-2 bg-white sticky top-0 z-30">
                <p className="text-[1.063rem] text-[#755B51] font-semibold">List of Log</p>
                <button onClick={onClose} className="bg-primary text-white p-1 rounded-md"><Icon name="close" size={1.25} /></button>
            </div>

            <div className="py-3">
                {!working && totalRecords > PAGE_SIZE && (
                    <div className="flex justify-start mt-4">
                        <Pagination perPage={PAGE_SIZE} totalRecords={totalRecords} onPageChange={setCurrentPage} currentPage={currentPage} />
                    </div>
                )}
                {/* Scrollable data area */}
                <div className="min-h-[300px] max-h-[370px] overflow-auto relative rounded-md border border-gray-300 mt-2">
                    {/* Sticky Table Header */}
                    <div className="flex bg-gray-100 text-xs font-medium text-slate-600 border-b border-gray-300 sticky top-0 z-20">
                        {item === 'syncDepartment' ? (
                            <>
                                <div className="w-1/2 px-2 py-2">Department Id</div>
                                <div className="w-1/4 px-2 py-2">Department Name</div>
                            </>
                        ) : item === 'syncVendor' ? (
                            <>
                                <div className="w-1/2 px-2 py-2">Vendor Name</div>
                                <div className="w-1/4 px-2 py-2">Date and Time Sync</div>
                                <div className="w-1/4 px-2 py-2">Access User</div>
                            </>
                        ) : item === 'syncAccounts' ? (
                            <>
                                <div className="w-1/2 px-2 py-2">Account Name</div>
                                <div className="w-1/4 px-2 py-2">Date and Time Sync</div>
                                <div className="w-1/4 px-2 py-2">Access User</div>
                            </>
                        ) : (
                            <>
                                <div className="w-1/2 px-2 py-2">Account Group Name</div>
                                <div className="w-1/4 px-2 py-2">Date and Time Sync</div>
                                <div className="w-1/4 px-2 py-2">Access User</div>
                            </>
                        )}
                    </div>

                    {working && (
                        <div className="flex items-center justify-center py-10">
                            <Loader />
                        </div>
                    )}

                    {!working && agrowData?.sageAccountGroupList?.map((row: any, index: number) => (
                        <div key={index} className="flex border-t text-sm text-gray-700">
                            <div className="w-1/2 px-2 py-2">{row?.accountGroupName || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{showLocalDateTime(row?.addedDate) || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{row?.addedByName || '-'}</div>
                        </div>
                    ))}

                    {!working && accrowData?.sageAccountList?.map((row: any, index: number) => (
                        <div key={index} className="flex border-t text-sm text-gray-700">
                            <div className="w-1/2 px-2 py-2">{`${row?.accountNo || ''}--${row?.accountTitle || ''}`.trim() || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{showLocalDateTime(row?.addedDate) || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{row?.addedByName || '-'}</div>
                        </div>
                    ))}

                    {!working && fbrowData?.sageFinancialBookList?.map((row: any, index: number) => (
                        <div key={index} className="flex border-t text-sm text-gray-700">
                            <div className="w-1/2 px-2 py-2">{row?.accountTitle || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{showLocalDateTime(row?.addedDate) || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{row?.addedByName || '-'}</div>
                        </div>
                    ))}

                    {!working && iglrowData?.sageItemGLList?.map((row: any, index: number) => (
                        <div key={index} className="flex border-t text-sm text-gray-700">
                            <div className="w-1/2 px-2 py-2">{row?.accountTitle || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{showLocalDateTime(row?.addedDate) || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{row?.addedByName || '-'}</div>
                        </div>
                    ))}

                    {!working && locrowData?.facilityList?.map((row: any, index: number) => (
                        <div key={index} className="flex border-t text-sm text-gray-700">
                            <div className="w-1/2 px-2 py-2">{row?.facilityName || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{showLocalDateTime(row?.addedDate) || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{row?.addedByName || '-'}</div>
                        </div>
                    ))}

                    {!working && deptrowData?.departmentList?.map((row: any, index: number) => (
                        <div key={index} className="flex border-t text-sm text-gray-700">
                            <div className="w-1/2 px-2 py-2">{row?.code || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{row?.name || '-'}</div>
                        </div>
                    ))}
                    {!working && vendorRowData?.vendorList?.map((row: any, index: number) => (
                        <div key={index} className="flex border-t text-sm text-gray-700">
                            <div className="w-1/2 px-2 py-2">{row?.vendorName || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{showLocalDateTime(row?.lastSyncDate) || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{row?.lastSyncByName || '-'}</div>
                        </div>
                    ))}
                    {!working &&
                        !agrowData?.sageAccountGroupList?.length &&
                        !accrowData?.sageAccountList?.length &&
                        !fbrowData?.sageFinancialBookList?.length &&
                        !iglrowData?.sageItemGLList?.length &&
                        !locrowData?.facilityList?.length &&
                        !deptrowData?.departmentList?.length &&
                        !vendorRowData?.vendorList?.length && (
                            <div className="p-4 text-center text-gray-400">No data found.</div>
                        )}
                </div>
            </div>

            {/* Footer */}
            <div className="flex justify-end gap-2 border-t border-[#8D6E63] pt-2">
                <Button type="button" theme="secondary" onClick={onClose}>
                    Close
                </Button>
            </div>
        </div>
    );
};

export default SageMDModalContent;